import { Grid, Tab } from 'semantic-ui-react';
import { isMobile } from 'react-device-detect';
import { find } from '../../../utils/lodash';
import { APP_NAME, ADMIN_SYSTEM_SETUP } from '../../../utils/constant';
import { CustomSegment } from '../../../components';
import '../admin.scss';
// import { exportSystemUsers } from '../../../store/actions';
import { ParentHelpComponent, IndustrySectorTypes, VenueTypes } from './forms';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Export from './forms/export';
import { useTranslation } from 'react-i18next';
// import { exportSystemUsers } from 'your-actions-file';

const SystemSetting = ({ match }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();
  // const { auth, user, helpTips } = useSelector(state => ({
  //   auth: state.authentication,
  //   user: state.authentication.user,
  //   helpTips: state.extra.activityHelpTips,
  //   ...state.user,
  // }));

  useEffect(() => {
    try {
      if (match.params.type) {
        changeRoute(match.params.type);
      }
    } catch (error) {
      console.error('error :', error);
    }
  }, [match.params.type]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = `${t('admin.system_settings.page_title')} | ${APP_NAME}`;
  }, [t]);

  const generateTabs = () => {
    const panes = [
      {
        menuItem: t('common.industry_sector_types'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab less-padding">
            <CustomSegment
              title={t('common.industry_sector_types')}
              children={<IndustrySectorTypes />}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.venue_types'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <CustomSegment
              title={t('common.venue_types')}
              children={<VenueTypes />}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('admin.system_settings.system_help'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <CustomSegment
              title={t('admin.system_settings.system_help_title')}
              children={<ParentHelpComponent />}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('admin.system_settings.system_data_export'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <CustomSegment
              title={t('admin.system_settings.system_data_export_title')}
              children={<Export />}
            />
          </Tab.Pane>
        ),
      },
    ];

    return panes;
  };

  const onTabClick = (data) => {
    changeRoute(data.activeIndex);
  };

  // const onClickUsersExport = async () => {
  //   await exportSystemUsersDispatch();
  // const { usersCsvLink } = this.props;
  //   if (!isEmpty(usersCsvLink)) {
  //     window.open(usersCsvLink.download_link, '_blank');
  //   }
  // };

  const changeRoute = async (value) => {
    try {
      const tab = await find(ADMIN_SYSTEM_SETUP(t), (o) => {
        return o.id === value || o.route === value;
      });
      setCurrentTab(tab.id);
      navigate(`/admin/system-settings/${tab.route}`);
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <Grid.Row>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={generateTabs()}
        className={isMobile ? 'custom-tabs-mobile' : 'custom-tabs'}
        activeIndex={currentTab}
        onTabChange={(e, data) => onTabClick(data)}
      />
    </Grid.Row>
  );
};

export default SystemSetting;
